export interface FlashItem {
  id: number;
  time: string;
  tag: string;
  title: string;
  summary: string;
  heat: number;
  level: 'hot' | 'new' | 'normal';
}

export const flashItems: FlashItem[] = [
  {
    id: 1,
    time: '09:12',
    tag: '综艺',
    title: '「某慢生活综艺」录制路透流出，两位常驻嘉宾全程零交流',
    summary: '现场瓜友发回的路透里，两人同框却各走各的动线，连眼神都欠奉，评论区已经开始排出时间线。',
    heat: 8620,
    level: 'hot',
  },
  {
    id: 2,
    time: '10:35',
    tag: '剧集',
    title: '古装新剧开机物料曝光，男二番位归属再起争议',
    summary: '官宣名单顺序与过往作品宣传位不一致，粉丝把三年前的海报都翻了出来做对比。',
    heat: 6140,
    level: 'new',
  },
  {
    id: 3,
    time: '11:48',
    tag: '音乐',
    title: '新专先行曲上线三小时，评论区口碑两极分化',
    summary: '一边夸旋律洗脑，一边嫌编曲寡淡，两拨人把这首歌顶上了热搜的尾巴。',
    heat: 4310,
    level: 'normal',
  },
  {
    id: 4,
    time: '13:20',
    tag: '品牌',
    title: '代言海报一天内二次更换，网友顺藤摸瓜排出时间线',
    summary: '从官宣到替换不到二十四小时，瓜友们把每一步截图都存进了合集里。',
    heat: 7290,
    level: 'hot',
  },
  {
    id: 5,
    time: '15:06',
    tag: '影视',
    title: '电影路演临时取消两站，主办方称系行程调整',
    summary: '临开场三小时通知取消，票务平台开始陆续退款，讨论区里说法不一。',
    heat: 3980,
    level: 'new',
  },
  {
    id: 6,
    time: '16:42',
    tag: '时尚',
    title: '红毯造型评分出炉，某女星礼服被指撞款三年前旧图',
    summary: '对比图一出，审美组和考古组同时上线，评论区直接变成设计课现场。',
    heat: 5560,
    level: 'normal',
  },
  {
    id: 7,
    time: '18:15',
    tag: '综合',
    title: '深夜发文又秒删，截图已被瓜友第一时间存下',
    summary: '发文到删除只隔了六分钟，好在瓜友的手比网速还快，原图已经在群里传开。',
    heat: 9130,
    level: 'hot',
  },
  {
    id: 8,
    time: '20:30',
    tag: '讨论',
    title: '本周讨论区最高赞长帖更新：番位到底该按什么算',
    summary: '楼主把咖位、戏份、官宣顺序三种算法逐一拆开，回帖已经排到第二十四页。',
    heat: 6740,
    level: 'new',
  },
];

export interface CollectionItem {
  id: number;
  no: string;
  title: string;
  desc: string;
  count: number;
  tone: 'primary' | 'accent' | 'secondary';
}

export const collections: CollectionItem[] = [
  {
    id: 1,
    no: '01',
    title: '年度大瓜年鉴',
    desc: '按月份归档，从开年到年底，一整年的时间线一次看全。',
    count: 128,
    tone: 'primary',
  },
  {
    id: 2,
    no: '02',
    title: '番位争议全记录',
    desc: '官宣顺序、海报站位、宣传物料，逐条比对，只摆事实。',
    count: 76,
    tone: 'accent',
  },
  {
    id: 3,
    no: '03',
    title: '红毯造型红黑榜',
    desc: '每一场大型活动的造型评分与高清图，审美组长期更新。',
    count: 214,
    tone: 'secondary',
  },
  {
    id: 4,
    no: '04',
    title: '剧集选角风云',
    desc: '从选角传闻到定妆照，把每一次换角都做成一页档案。',
    count: 93,
    tone: 'primary',
  },
  {
    id: 5,
    no: '05',
    title: '综艺名场面回收站',
    desc: '笑点、名场面、微妙瞬间，按节目分类，随时回看。',
    count: 168,
    tone: 'accent',
  },
  {
    id: 6,
    no: '06',
    title: '瓜友考古档案',
    desc: '大家一起来翻旧图，老瓜新吃，证据链一条条接起来。',
    count: 57,
    tone: 'secondary',
  },
];

export interface TopicItem {
  id: number;
  category: string;
  title: string;
  author: string;
  replies: number;
  likes: number;
  lastReply: string;
  pinned?: boolean;
}

export const topics: TopicItem[] = [
  {
    id: 1,
    category: '剧集',
    title: '「某剧男女主对手戏」到底是演技还是氛围感，来掰扯一下',
    author: '深夜码字的瓜友',
    replies: 486,
    likes: 1970,
    lastReply: '3 分钟前',
    pinned: true,
  },
  {
    id: 2,
    category: '讨论',
    title: '吃瓜到底要不要讲证据链？说说你给自己定的底线',
    author: '只吃熟瓜',
    replies: 312,
    likes: 1540,
    lastReply: '12 分钟前',
  },
  {
    id: 3,
    category: '考古',
    title: '来聊聊你心里最难被超越的那一路透神图',
    author: '翻旧账选手',
    replies: 268,
    likes: 1120,
    lastReply: '25 分钟前',
  },
  {
    id: 4,
    category: '综艺',
    title: '今天这条快讯，你们最在意的是哪一句',
    author: '蹲点小组',
    replies: 194,
    likes: 860,
    lastReply: '41 分钟前',
  },
  {
    id: 5,
    category: '时尚',
    title: '红毯撞款算不算大事？设计角度聊两句',
    author: '审美组组长',
    replies: 156,
    likes: 720,
    lastReply: '1 小时前',
  },
  {
    id: 6,
    category: '新人',
    title: '新人报道帖：刚进瓜友群，想问下大家的入坑顺序',
    author: '今天才入坑',
    replies: 88,
    likes: 340,
    lastReply: '2 小时前',
  },
];

export interface GroupItem {
  id: number;
  name: string;
  members: string;
  desc: string;
  tag: string;
}

export const groups: GroupItem[] = [
  {
    id: 1,
    name: '实时爆料群',
    members: '12,860 人',
    desc: '谁先看到谁先说，最快的料通常在这里冒头。',
    tag: '爆料',
  },
  {
    id: 2,
    name: '剧集讨论群',
    members: '8,420 人',
    desc: '追同一部剧的人凑一桌，更新日的吐槽最密集。',
    tag: '追剧',
  },
  {
    id: 3,
    name: '综艺闲聊群',
    members: '6,105 人',
    desc: '名场面、名台词、名剪辑，边看边聊不冷场。',
    tag: '闲聊',
  },
  {
    id: 4,
    name: '红毯审美群',
    members: '4,730 人',
    desc: '造型打分、高清图共享，审美组的主场。',
    tag: '审美',
  },
  {
    id: 5,
    name: '新人瓜友群',
    members: '9,980 人',
    desc: '刚来的先自我介绍，老瓜友会带你补档。',
    tag: '新人',
  },
];

export const tickerTags: string[] = [
  '实时爆料',
  '讨论区热议',
  '瓜友群在线',
  '合集索引已更新',
  '今日快讯 37 条',
  '考古档案翻新',
  '红毯审美组在线',
];